import MemoCard from "../Model/MemoCard";
import Network from "../../Shared/Util/Network";

interface MemoCardViewProps {
    card: MemoCard
    onSelect : () => void
}

export function MemoCardView(props: MemoCardViewProps) {
    return <div className={"memo-card " + props.card.state} onClick={props.onSelect}>
        <div className="background">
            <div className="wrapper">
                <div className="front" style={{
                    backgroundImage : 'url(' + Network.pictureUrl(props.card.question.picture) + ')'
                }}> </div>
                <div className="back"><img src="images/shared/logo-mono.png" alt="Logo"/> </div>
            </div>
        </div>
    </div>;
}